// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__EagIJ"};